if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value;
        if (!value) return;
        const form = select.closest('[data-localization-form]');
        if (!form) return;
        const input = form.querySelector('input[data-localization-input]');
        if (!input) return;
        input.value = value;
        form.submit();
      });
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}